import React from "react";
import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function PublicNav() {
  const { user } = useAuth();
  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/75 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="public-nav-logo">
          <div className="w-8 h-8 bg-orange-600 grid place-items-center rounded-sm">
            <Award className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-black tracking-tight">
            PLATINUM<span className="text-orange-600">1</span>
          </span>
        </Link>
        <div className="flex items-center gap-6 text-sm font-medium text-slate-700">
          <Link to="/blog" data-testid="public-nav-blog" className="hover:text-orange-600">Blog</Link>
          <Link to="/pricing" data-testid="public-nav-pricing" className="hover:text-orange-600">Pricing</Link>
          <Link
            to={user ? "/dashboard" : "/register"}
            data-testid="public-nav-cta"
            className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-sm font-semibold"
          >
            {user ? "Dashboard" : "Get Certified"}
          </Link>
        </div>
      </div>
    </nav>
  );
}
